import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import bronzeCrateImageSrc from '../../../assets/images/prelander/bronze-crate.png';
import silverCrateImageSrc from '../../../assets/images/prelander/silver-crate.png';
import goldCrateImageSrc from '../../../assets/images/prelander/gold-crate.png';
import styles from './GameProgressBar.css';

const cx = classnames.bind(styles);

const BUNDLES_INFORMATION_LIST = [
    {
        imageUrl: bronzeCrateImageSrc,
        count: 2
    },
    {
        imageUrl: silverCrateImageSrc,
        count: 2
    },
    {
        imageUrl: goldCrateImageSrc,
        count: 6
    }
];

function GameProgressBar({
    className,
    progressList
}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });

    return (
        <div className={classes}>
            <p className={styles.title}>Game progress</p>
            <div className={styles.progressBar}>
                {progressList.map((percent, index) => {
                    const {imageUrl, count} = BUNDLES_INFORMATION_LIST[index];

                    return (
                        <div
                            className={styles.wrapper}
                            key={index}
                        >
                            <div className={styles.progressBarThumb}>
                                <div
                                    className={styles.progressBarActive}
                                    style={{width: `${percent}%` }}
                                />
                            </div>
                            <div className={styles.information}>
                                <span className={styles.count}>{count}x</span>
                                <img
                                    src={imageUrl}
                                    className={styles.image}
                                    alt='bundle'
                                />
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    );
};

GameProgressBar.propTypes = {
    className: PropTypes.string,
    progressList: PropTypes.array
};

GameProgressBar.defaultProps = {
    className: '',
    progressList: [0, 0, 0]
};

export {
    GameProgressBar
}
